/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 14,
    height: 16,
    viewBox: '0 0 14 16',
    data: '<path pid="0" d="M9.857.857v2.857M4.143.857v2.857M.57 6.571h12.857M2 2.286h10c.789 0 1.428.64 1.428 1.428v10c0 .79-.64 1.429-1.428 1.429H2c-.79 0-1.429-.64-1.429-1.429v-10c0-.789.64-1.428 1.429-1.428z" _stroke="#5C5A74" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/calendar.js